export function buildBasicFilterValues(filterConfig, table) {
  return Object.fromEntries(
    Object.entries(filterConfig).map(([key, colId]) => [
      key,
      table.getColumn(colId)?.getFilterValue(),
    ])
  )
}

export function buildPrefixedFilterValue(filterValue, prefix) {
  return (Array.isArray(filterValue) ? filterValue : [])
    .filter((value) => value.startsWith(prefix))
    .map((value) => value.replace(prefix, ""))
}

export function applyLeftClickFilter(table, columnId, value) {
  const column = table.getColumn(columnId)
  if (!column) return

  const current = column.getFilterValue()
  const values = Array.isArray(current) ? current : []

  const nextValues =
    values.includes(value) ?
      values.filter((v) => v !== value)
    : [...values, value]

  column.setFilterValue(nextValues.length ? nextValues : undefined)
}
